export default "__VITE_ASSET__KkbTqWJ1__"